/**
 * `restore-daily-version` plan. Single atomic call on the BE
 * (`POST /api/v2/route/{routeId}/daily/stops/restore`); the pipeline is
 * preflight + the one step + verify. Strategy-independent — `v1-bulk` reuses
 * this with its own strategy label since there's no v1-era restore endpoint.
 */

import { makePreflightStep } from '../steps/preflight'
import { makeRestoreDailyVersionStep } from '../steps/restoreDailyVersion'
import { makeVerifyStep } from '../steps/verify'

import type { Deps, OperationPlan, PipelineStep, RestoreDailyVersionIntent } from 'types/modules/routing'

const STRATEGY_ID = 'v2-pipeline' as const

export const buildRestoreDailyVersionPipeline = (intent: RestoreDailyVersionIntent, deps: Deps): OperationPlan => ({
  strategy: STRATEGY_ID,
  intent,
  steps: [
    makePreflightStep({ intent }, deps) as PipelineStep,
    makeRestoreDailyVersionStep(
      {
        routeId: intent.routeId,
        versionId: intent.versionId,
        reassign: intent.reassign,
      },
      deps
    ) as PipelineStep,
    makeVerifyStep({ intent }, deps) as PipelineStep,
  ],
})
